import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getClassroomAvailabilityAction } from '../actions';

const {
  useLoader: useContinuousEducationSectionClassroomLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getClassroomAvailabilityAction,
});

function ContinuousEducationSectionClassroomLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export {
  ContinuousEducationSectionClassroomLoader,
  useContinuousEducationSectionClassroomLoader,
};
